import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loader from "../../core/common/selfLoder";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import { is_manager } from "../../environment";
import useApi from "../../core/customhook/useApi";
import { getFinancialYearList, getFinancialYearListNew } from "../../core/common/financialYear";

const PMSGrid = () => {
  const [loading, setLoading] = useState(true);

  const [finance_year, setFinance_year] = useState("");

  const {
    data: finYearData,
    loading: finYearLoading,
    error: finYearError,
  } = useApi("/api/get-apprisal-fin-year", {
    method: "GET",
    autoCall: true,
  });

  useEffect(() => {
    if (finYearData?.data?.fin_year) {
      setFinance_year(finYearData.data.fin_year);
    }
  }, [finYearData]);

  const {
    data,
    error,
    loading: categoryLoading,
  } = useApi("/api/manager/view-category", {
    method: "POST",
    autoCall: !!finance_year,
    payload: {
      financial_year: finance_year,
    },
    dependencies: [finance_year],
  });

  const {
    data: goalSetting,
    error: goalSettingerror,
    loading: goalSettingLoading,
  } = useApi("/api/get-goal-setting-timing", {
    method: "POST",
    autoCall: !!finance_year,
    payload: {
      financial_year: finance_year,
    },
    dependencies: [finance_year],
  });

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timeout);
  }, []);
  const hasNoCategory = !data?.data || !data?.data?.category_id;
  const baseGrid = [
    {
      name: "My Goals ",
      logo: "../assets/img/dashboard/MY-Goals.png",
      Link: "/performance/performance-review",
    },
    // {
    //   name: "User Guide ",
    //   logo: "../assets/img/dashboard/user-guide.png",
    //   Link: "/performance/user-guide",
    // },
  ];
  if (
    hasNoCategory ||
    data?.data?.status === "In progress" ||
    data?.data?.status === "Rejected"
  ) {
    if (
      goalSetting?.data?.extended_last_date &&
      goalSetting?.data?.status === "Started"
    ) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const lastDate = new Date(goalSetting.data.extended_last_date);
      lastDate.setHours(0, 0, 0, 0);

      console.log("Normalized lastDate:", lastDate);
      console.log("Normalized today:", today);

      if (lastDate >= today) {
        baseGrid.push({
          name: "Create Goals",
          logo: "../assets/img/dashboard/Create-Goals.png",
          Link: "/pms-goals-summary",
        });
      }
    }
  }

  if (is_manager === "true") {
    baseGrid.push({
      name: "Team Goals",
      logo: "../assets/img/dashboard/Team-Goals.png",
      Link: "/pms-employee-goals",
    });
  }
  // if (is_manager === "true") {
  //   if (
  //     goalSetting?.data?.extended_manager_last_date &&
  //     goalSetting?.data?.status === "Started"
  //   ) {
  //     const today = new Date();
  //     today.setHours(0, 0, 0, 0);

  //     const managerLastDate = new Date(
  //       goalSetting.data.extended_manager_last_date
  //     );
  //     managerLastDate.setHours(0, 0, 0, 0);

  //     if (managerLastDate >= today) {
  //       baseGrid.push({
  //         name: "Team Goals",
  //         logo: "../assets/img/dashboard/Team-Goals.png",
  //         Link: "/pms-employee-goals",
  //       });
  //     }
  //   }
  // }

  const LeaveGrid = baseGrid;

  return (
    <>
      <Loader loading={loading} />
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Work & Operations</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/employee-dashboard">
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Work & Operations</li>
                  <li className="breadcrumb-item">PMS</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Goal Settings
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="input-icon w-120 position-relative mb-2">
                <span className="input-icon-addon">
                  <i className="ti ti-calendar text-gray-9" />
                </span>

                <select
                  value={finance_year}
                  onChange={(e) => setFinance_year(e.target.value)}
                  className="form-select"
                >
                  {getFinancialYearListNew(finance_year).map((fy) => (
                    <option key={fy} value={fy}>
                      {fy}
                    </option>
                  ))}
                </select>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Goal Settings</h5>
            </div>
            <div className="card-body">
              <div className="row h-100">
                {LeaveGrid.map((card, index) => (
                  <div
                    key={index}
                    className="col-6 col-sm-4 col-md-3 mb-4 d-flex"
                  >
                    <Link to={card.Link} className="w-100">
                      <div className="card h-100 shadow-sm px-2 py-3 px-md-4 px-md-4 d-flex flex-column align-items-center justify-content-center text-center">
                        <img
                          src={card.logo}
                          alt={card.name}
                          className="mb-3"
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "contain",
                          }}
                        />
                        <h5 className="mb-0">{card.name}</h5>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>
    </>
  );
};

export default PMSGrid;
